import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

const apiPrefix = '/user-mgmt/v1/';

const commonRoutes = {
  getNotificationConfigList: () => apiPrefix + `user-notification-config`,
  updateNotificationConfigList: () => apiPrefix + `user-notification-config`,
};

@Injectable({
  providedIn: 'root'
})
export class ConfigPanelService {

  constructor(private http: HttpClient) { }

  getNotificationConfigList() {
    const $configList: Observable<any> = this.http
        .get(commonRoutes.getNotificationConfigList())
        .pipe(
            map(
                (x) => {
                  return x as any;
                }
            )
        );
    return $configList;
  }

  updateNotificationConfigList(notificationRequestBody: any) {
    const $configList: Observable<any> = this.http
        .put(commonRoutes.updateNotificationConfigList(), notificationRequestBody)
        .pipe(
            map(
                (x) => {
                  return x as any;
                }
            )
        );
    return $configList;
  }

}
